var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "pagination-wrapper clearfix row align-items-center no-gutters",
    },
    [
      _vm.showPaginationInfo
        ? _c("div", {
            staticClass: "pagination-info",
            class: _vm.paginationInfoClass,
            domProps: { innerHTML: _vm._s(_vm.paginationInfo) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.collection.hasPagination
        ? _c(
            "ul",
            {
              staticClass: "pagination",
              class: [
                {
                  "pagination-sm": _vm.size == "small",
                  "pagination-lg": _vm.size == "large",
                  "justify-content-center": _vm.align == "center",
                  "justify-content-end": _vm.align == "right",
                },
                _vm.paginationComponentClass,
              ],
              attrs: { role: "navigation" },
            },
            [
              _vm.collection.shouldRenderLinks
                ? [
                    _c(
                      "li",
                      {
                        staticClass: "page-item",
                        class: { disabled: !_vm.collection.hasPreviousPage },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { rel: "prev", "aria-label": "« Previous" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.collection.previousPage()
                              },
                            },
                          },
                          [_vm._v("‹")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.collection.pagination, function (page, index) {
                      return [
                        _vm.collection.isCurrentPage(page)
                          ? _c(
                              "li",
                              {
                                staticClass: "page-item active",
                                attrs: { "aria-current": "page" },
                              },
                              [
                                _vm.loading
                                  ? _c("span", { staticClass: "page-link" }, [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-circle-notch fa-spin",
                                      }),
                                    ])
                                  : _c("span", { staticClass: "page-link" }, [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(page) +
                                          "\n                    "
                                      ),
                                    ]),
                              ]
                            )
                          : _c(
                              "li",
                              {
                                staticClass: "page-item",
                                class: { disabled: page === "..." },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "page-link",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.collection.page(page)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(page) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    }),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "page-item",
                        class: { disabled: !_vm.collection.hasNextPage },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { rel: "next", "aria-label": "Next »" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.collection.nextPage()
                              },
                            },
                          },
                          [_vm._v("›")]
                        ),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "li",
                      {
                        staticClass: "page-item disabled",
                        attrs: { "aria-current": "page" },
                      },
                      [
                        _vm.loading
                          ? _c("span", { staticClass: "page-link" }, [
                              _c("i", {
                                staticClass: "fa fa-circle-notch fa-spin",
                              }),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showPerPage && _vm.collection.hasItems
        ? _c(
            "div",
            {
              staticClass: "pagination-perpage",
              class: _vm.paginationInfoPerPageClass,
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-row justify-content-center justify-content-sm-end align-items-center",
                },
                [
                  _c("div", {
                    staticClass: "prefix d-none d-sm-inline",
                    class: [_vm.prefixPerPageInfo != "" ? "pr-2" : ""],
                    domProps: { innerHTML: _vm._s(_vm.prefixPerPageInfo) },
                  }),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.collection.perPage,
                          expression: "collection.perPage",
                        },
                      ],
                      staticClass: "form-control form-control-sm w-auto",
                      attrs: {
                        name: "pagination-dropdown",
                        "aria-controls": "pagination-dropdown",
                      },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.collection,
                            "perPage",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.collection.perPageOptions, function (amount) {
                      return _c("option", { domProps: { value: amount } }, [
                        _vm._v(_vm._s(amount)),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "suffix d-none d-sm-inline",
                    class: [_vm.suffixPerPageInfo != "" ? "pl-2" : ""],
                    domProps: { innerHTML: _vm._s(_vm.suffixPerPageInfo) },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }